module.exports = __webpack_public_path__ + "static/qh_27.cbb8c6cc.jpg";